import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.baseURL = 'http://135.181.37.65/api'

export default new Vuex.Store({
    state: {
        items: []
    },
    mutations: {},
    actions: {
        async retrieveStatus() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/status')
                    .then(response => {
                        //context.commit('setPages', response.data.pages)
                        resolve(response.data)
                    })
                    .catch(e => {
                        reject(e)
                    })
            })
        }
    },
    modules: {}
})
